import React, { useEffect } from 'react'
import CommonTablePage from '../../../../components/common/common-table/common-table-page'
import CustomerGroup5ManagementColumnModel from './customer-group5-management-column-model'
import { urlKey } from '../../../../services/api/api-urls'
import { useDocumentTitle } from '../../../../services/title/useDocumentTitle'

const CustomerGroup5ManagementPage = (): any => {
  // useEffect(() => {
  //   document.title = "Customer Group 5 Management";
  //   },[]); 
    useDocumentTitle(); 
  return (
    <CommonTablePage
      urlInfoKey={urlKey.CustomerGroup5}
      title="Customer Group 5 Management"
      column={CustomerGroup5ManagementColumnModel.CustomerGroup5ManagementColumn}
    />
  )
}

export default CustomerGroup5ManagementPage
